export { ResponsiveBackgroundContainer } from './ResponsiveBackgroundContainer'
